import { GetStaticProps } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import ENV_VARS from '@/config'
import { makeMainLayout } from '@/layouts/main'
import AlbertaLandlordsFeature from '@/features/AlbertaLandords'
import { HeaderTheme } from '@/features/Header'
import Head from '@/components/head'

const { BASE_URL } = ENV_VARS

function AlbertaLandords() {
  const { t } = useTranslation('landlords')

  return (
    <>
      <Head
        title={t(
          'landlords:Free Trial For Alberta Landlords | Post Rental For Free | liv.rent'
        )}
        description={t(
          `landlords:Start your free trial today and list your rental property in Alberta. Attract quality renters quickly with our advertising and screening features.`
        )}
        meta={{
          image: `${BASE_URL}/images/free-trial-alberta-landlords-liv.rent.jpg`,
          imageAlt: t('landlords:free trial alberta landlords liv rent')
        }}
        path="/landlords/free-trial-alberta"
      ></Head>
      <AlbertaLandlordsFeature />
    </>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale = '' }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['translation', 'landlords']))
    }
  }
}
const headerConfig = {
  theme: HeaderTheme.TRANSPARENT,
  showNavItems: true,
  showSearch: false
}

AlbertaLandords.Layout = makeMainLayout({ headerConfig })

export default AlbertaLandords
